<template>

  <modal name="createSectionModal" tabindex="-1" @closed="hideModal" role="dialog" aria-hidden="true">
    <div class="row p-4">
      <div class="col-md-12">
        <button @click="hideModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">
            &times;
          </span>
        </button>
        <textarea
          @keyup.enter="createSection()"
          v-model="name"
          ref="createSectionInput"
          spellcheck="false"
          @input="adjustTextArea()"
          placeholder="Set section name"
          rows="1"
          class="form-control form-control-flush"
          style="font-size: 1.5rem; resize: none; text-shadow: 0 0.5px gainsboro;" />
        <div class="row mt-4">
          <div class="col-12">
            <div class="">
              <button v-on:click="createSection" type="button" class="btn btn-sm btn-primary float-right "><i
                class="fe fe-check-circle mr-2"></i>{{ $t('modals.create_task_modal.create') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'EditSectionModal',
    data () {
      return {
        drag: false,
        name: '',
        unique_id: null,
      };
    },

    computed: {
      ...mapGetters([
        'window',
        'show_modal_create_section',
        'selected_project_id',
        'selected_duration',
      ]),
    },
    watch: {
      show_modal_create_section: function () {
        if (this.show_modal_create_section) {
          this.$modal.show('createSectionModal');
          setTimeout(() => this.adjustTextArea(), 600);
          setTimeout(() => this.$refs.createSectionInput.focus(), 850);
        }
      },
    },

    methods: {
      createSection () {
        const newSection = {
          name: this.name,
          project_id: this.selected_project_id,
        };
        this.name = '';
        this.$modal.hide('createSectionModal');
        this.$store.dispatch('createSection', newSection);
        this.$noty.success('Section created successfully');
      },
      adjustTextArea () {
        if (this.$refs.createSectionInput) {
          this.$refs.createSectionInput.style.height = 0;
          this.$refs.createSectionInput.style.height = Math.min(this.$refs.createSectionInput.scrollHeight, this.window.height - 250) + 'px';
        }
      },
      hideModal () {
        this.$store.commit('hideModal', 'create_section');
        this.$modal.hide('createSectionModal');
      },
    },
    created: function () {
      this.unique_id = Math.random().toString();
      setTimeout(() => this.adjustTextArea(), 800);
    },
    destroyed () {
    },
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  html, body {
    width: 100%;
    height: 100%;
  }

</style>
